"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _goodsListing = _interopRequireDefault(require("./goodsListing.vue"));
var _groupListing = _interopRequireDefault(require("./groupListing.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '商品上下架',
  components: {
    goodsListing: _goodsListing.default,
    groupListing: _groupListing.default
  },
  data: function data() {
    return {
      activeName: 'goods'
    };
  }
};